import '../grouped_elements/grouped_elements_filter_view.js.coffee'
Monitoring.Views.SocialContents.Filters ||= {}
Monitoring.Views.SocialContents.Filters.GroupedElements ||= {}

class Monitoring.Views.SocialContents.Filters.CustomerLabelsFilterView extends Monitoring.Views.SocialContents.Filters.GroupedElementsFilterView

  template: JST["backbone/templates/monitoring/filters/grouped_elements/customer_grouped_elements_filter_modal"]

  name: 'label'
  facetName: 'label'
  alias: 'Group'
  addMissing: true
  selectAll: true

  initialize: (@options = {}) ->
    super(@options)
    @terms = @options.terms
    @initializeGroups()

  getGroupsLogic: () ->
    @initializeGroups()
    'first_group_elements':    @primaryLabelsLogic,
    'second_group_elements':   @secondaryLabelsLogic,
    'excluded_group_elements': @excludedLabelsLogic

  getGroupsElements: () ->
    first_group_elements: @withPrefix('primary_labels')
    second_group_elements: @withPrefix('secondary_labels')
    excluded_group_elements: @withPrefix('excluded_labels')

  someValueSelected: =>
    @firstGroupView.appliedElements.length > 0 ||
      @secondGroupView.appliedElements.length > 0 ||
      @excludedGroupView.appliedElements.length > 0

  viewFor: (viewId) =>
    view = new Monitoring.Views.SocialContents.Filters.LabelsFilterGroupView(@optionsFor(viewId))
    @listenTo(view, 'GroupedElementsSelectView:onChange', @onGroupChange)
    view

  onGroupChange:->
    @trigger('change')
    @_keepCustomerSessionAlive()

  titles: ->
    first_group_elements: I18n.t('monitoring.taxonomy.first_group')
    second_group_elements: I18n.t('monitoring.taxonomy.second_group')
    excluded_group_elements: I18n.t('monitoring.taxonomy.excluded_group')

  initializeGroups:->
    @customerFilter = @options.customerFilter
    intelligent_groups = @customerFilter.intelligent_groups
    @mainGroups = @mainGroups || intelligent_groups.main_groups || []
    @secondaryGroups = @secondaryGroups || intelligent_groups.secondary_groups || []
    @excludedGroups = @excludedGroups || intelligent_groups.excluded_groups || []

    @primaryLabelsLogic = @primaryLabelsLogic || intelligent_groups.main_groups_logic
    @secondaryLabelsLogic = @secondaryLabelsLogic || intelligent_groups.secondary_groups_logic
    @excludedLabelsLogic = @excludedLabelsLogic || intelligent_groups.excluded_groups_logic

  onApply: =>
    @_keepCustomerSessionAlive()

    @mainGroups = _.map(@firstGroupView.appliedElements, (appliedElement) -> appliedElement.term)
    @secondaryGroups = _.map(@secondGroupView.appliedElements, (appliedElement) -> appliedElement.term)
    @excludedGroups = _.map(@excludedGroupView.appliedElements, (appliedElement) -> appliedElement.term)

    @primaryLabelsLogic = @firstGroupView.logic
    @secondaryLabelsLogic = @secondGroupView.logic
    @excludedLabelsLogic = @excludedGroupView.logic


  _generateAllElements: (terms) ->
    _.map(terms, (term) ->
      return {term: term.description}
    )

  _determineAppliedElements: (group) ->
    if group== 'primary_labels'
      return _.map(@mainGroups, (appliedElement) => {term: appliedElement})
    if group== 'secondary_labels'
      return _.map(@secondaryGroups, (appliedElement) => {term: appliedElement})
    if group== 'excluded_labels'
      return _.map(@excludedGroups, (appliedElement) => {term: appliedElement})

  _filterUsedElements: (all_elements, applied_elements) =>
    applied_elements_names = _.map(applied_elements, (appliedElement) => appliedElement.term)
    result = {"possible": [], "applied": []}
    _.each all_elements, (element) ->
      if element.term in applied_elements_names
        result["applied"].push element
        element.applied = true
      else
        element.applied = false
      result["possible"].push element
    result

  elementNameWithCounter: (element) ->
    element

  elementName: (element)->
    element

  canFilterOnlyPresent: ->
    false

  getName: () ->
    'labels'

  _noValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.groups.no_groups')

  _allValuesDescription: ->
    I18n.t('customer.dashboard.filters.creation.groups.all_groups')

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
